class GrowthExecutiveHeroBanner {
    constructor(wrapperEl, smallGridSize = 8, largeGridSize = 64, smallGridColor = '#113748', largeGridColor = '#234b7c', largeGridOffset = -29) {
        this.element = wrapperEl;
        this.smallGridSize = smallGridSize;
        this.largeGridSize = largeGridSize;
        this.smallGridColor = smallGridColor;
        this.largeGridColor = largeGridColor;
        this.largeGridOffset = largeGridOffset;
        this.lines = [];
        this.lineThickness = 3;
        this.lineLength = 60;
        this.lineColor = '38, 109, 173';
        this.lineCount = 5;
        this.opacity = 0.4;
        this.init();
    }

    init() {
        this.canvas = document.createElement('canvas');
        this.ctx = this.canvas.getContext('2d');
        this.element.appendChild(this.canvas);
        this.handleResize = this.handleResize.bind(this);
        this.dpr = window.devicePixelRatio || 1;
        window.addEventListener('resize', this.handleResize);
        this.setCanvasSize();
        for(let i = 0; i < this.lineCount; i++) {
            this.lines.push(this.createLine());
        }
        this.draw();
        this.animate();
    }

    createLine() {
        const horizontal = Math.random() >= 0.5;
        const maxGridDimension = horizontal ? this.canvas.height : this.canvas.width;
        const maxNumCells = Math.floor(maxGridDimension / this.largeGridSize);
        const rowOrColumn = Math.floor(Math.random() * maxNumCells);
        const speed = (Math.random() * 2 + 1) * (Math.random() < 0.5 ? -1 : 1) / 5;
        const pos = speed > 0 ? -this.lineLength : (horizontal ? this.canvas.width + this.lineLength: this.canvas.height + this.lineLength);
        for(let i = 0; i < this.lines.length; i++) {
            const line = this.lines[i];
            if(line.horizontal === horizontal && line.rowOrColumn === rowOrColumn) {
                return this.createLine();
            }
        }

        return { horizontal, pos, speed, rowOrColumn };
    }

    setCanvasSize() {
        this.canvas.width = this.element.offsetWidth * this.dpr;
        this.canvas.height = this.element.offsetHeight * this.dpr;
        this.ctx.scale(this.dpr, this.dpr);
        this.width = this.canvas.width;
        this.height = this.canvas.height;
    }

    draw() {
        this.ctx.clearRect(0, 0, this.width, this.height);
        this.ctx.lineWidth = 1;

        this.ctx.strokeStyle = this.smallGridColor;
        for(let i = 0; i <= this.width / this.dpr; i += this.smallGridSize) {
            this.ctx.beginPath();
            this.ctx.moveTo(i, 0);
            this.ctx.lineTo(i, this.height / this.dpr);
            this.ctx.stroke();
        }
        for(let i = 0; i <= this.height / this.dpr; i += this.smallGridSize) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, i);
            this.ctx.lineTo(this.width / this.dpr, i);
            this.ctx.stroke();
        }

        this.ctx.strokeStyle = this.largeGridColor;
        const offsetX = this.largeGridOffset;
        const offsetY = this.largeGridOffset;
        for(let i = offsetX; i <= this.width / this.dpr; i += this.largeGridSize) {
            this.ctx.beginPath();
            this.ctx.moveTo(i, 0);
            this.ctx.lineTo(i, this.height / this.dpr);
            this.ctx.stroke();
        }
        for(let i = offsetY; i <= this.height / this.dpr; i += this.largeGridSize) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, i);
            this.ctx.lineTo(this.width / this.dpr, i);
            this.ctx.stroke();
        }

        this.ctx.lineWidth = this.lineThickness;
        this.lines.forEach(line => {
            this.ctx.beginPath();
            this.ctx.strokeStyle = `rgba(${this.lineColor},${this.opacity})`;
            this.ctx.lineCap = 'round';
            if(line.horizontal) {
                this.ctx.moveTo(line.pos + this.largeGridOffset, line.rowOrColumn * this.largeGridSize + this.largeGridOffset);
                this.ctx.lineTo(line.pos + this.lineLength + this.largeGridOffset, line.rowOrColumn * this.largeGridSize + this.largeGridOffset);
            } else {
                this.ctx.moveTo(line.rowOrColumn * this.largeGridSize + this.largeGridOffset, line.pos + this.largeGridOffset);
                this.ctx.lineTo(line.rowOrColumn * this.largeGridSize + this.largeGridOffset, line.pos + this.lineLength + this.largeGridOffset);
            }
            this.ctx.stroke();
        });
    }

    animate() {
        this.lines.forEach(line => {
            line.pos += line.speed;
            const maxPos = (line.horizontal ? this.canvas.width : this.canvas.height);
            if(line.speed > 0 && line.pos - this.lineLength > maxPos || line.speed < 0 && line.pos + this.lineLength < 0) {
                Object.assign(line, this.createLine());
            }
        });
        this.draw();
        requestAnimationFrame(() => this.animate());
    }


    handleResize() {
        this.setCanvasSize();
        this.draw();
    }
}
export default GrowthExecutiveHeroBanner;
